import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconStar } from '@tabler/icons';
import { getAllData } from '../../redux/actions/api/GetAllData';
import Breadcrumb from '../../components/breadcrumb/Breadcrumb';
import Loading from '../../components/loading/Loading';
import { isObject } from 'lodash';

export default function Footer() {
  const dispatch = useDispatch();
  const { accessToken } = useSelector((state) => state?.auth);
  const { data: info, loading, error } = useSelector((state) => state?.api);
  useEffect(() => {
    dispatch(getAllData('informations', accessToken));
  }, [accessToken, dispatch]);
  return (
    <>
      <Breadcrumb
        url='/footer/edit'
        title='All information about footer'
        textActive='Footer'
        btnText='Edit Footer'
      />
      {loading ? (
        <Loading isLoading={loading} />
      ) : error ? (
        error
      ) : (
        <div className='container-fluid'>
          <div className='row col-11 col-md-8 m-auto details-info card pe-0'>
            <div className='ribbon ribbon-top bg-yellow'>
              <IconStar />
            </div>
            <div className='row px-0'>
              <div className='col-md-6 pt-4 border-bottom border-end border-start'>
                <div className='row'>
                  <div className='col-md-4'>
                    <h3 className='title'>Phone :</h3>
                  </div>
                  <div className='col-md-8'>
                    <h4 className='sub-title'>{info?.phone}</h4>
                  </div>
                </div>
              </div>
              <div className='col-md-6 pt-4 border-bottom border-end border-start'>
                <div className='row'>
                  <div className='col-md-4'>
                    <h3 className='title'>Email :</h3>
                  </div>
                  <div className='col-md-8'>
                    <h4 className='sub-title'>{info?.email}</h4>
                  </div>
                </div>
              </div>
              <div className='col-md-12 pt-4 border-bottom border-end border-start'>
                <div className='row'>
                  <div className='col-md-4'>
                    <h3 className='title'>Address en :</h3>
                  </div>
                  <div className='col-md-8'>
                    <h4 className='sub-title'>{info?.address_en}</h4>
                  </div>
                </div>
              </div>
              <div className='col-md-12 pt-4 border-bottom border-end border-start'>
                <div className='row'>
                  <div className='col-md-4'>
                    <h3 className='title'>Address ar :</h3>
                  </div>
                  <div className='col-md-8'>
                    <h4 className='sub-title'>{info?.address_ar}</h4>
                  </div>
                </div>
              </div>
              <h3 className='text-ms bg-gradient-info p-2 text-gray-100 border-start'>
                Social Media Links :-{' '}
              </h3>
              {isObject(info?.social_media) ? (
                Object.entries(info?.social_media)?.map(([key, value]) => (
                  <div
                    key={key}
                    className='col-md-12 pt-4 border-bottom border-end border-start'
                  >
                    <div className='row'>
                      <div className='col-md-4'>
                        <h3 className='title'>{key} :</h3>
                      </div>
                      <div className='col-md-8'>
                        <h4 className='sub-title'>{value} </h4>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className='col-md-12 text-error text-center'>
                  You have not add any data social media links
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
